<div
    id="dashboard"
    class="container-fluid">
    <div id="dashboard-header">
        <h4>My dashboard</h4>

        <!-- TODO: buttons on right hand side -->
        <div class="pull-right mtm30">
            <span>
                <i
                    class="nlrp-icon nlrp-icon-refresh-reload"
                    title="Refresh all data within my dashboard"
                    id="refreshDataBtn"
                    (click)="populateCustomerPlans(false)"
                    nlr-click-once
                    tabindex="0">
                </i>
            </span>
            <span>
                <i
                    class="nlrp-icon nlrp-icon-zoom-out"
                    alt="Decrease font size"
                    id="decreaseFontBtn"
                    title="Decrease font size within my dashboard"
                    (click)="adjustFontSize(-2)"
                    nlr-click-once
                    tabindex="0"></i>
            </span>
            <span>
                <i
                    class="nlrp-icon nlrp-icon-zoom-in"
                    alt="Increase font size"
                    id="increaseFontBtn"
                    title="Increase font size within my dashboard"
                    (click)="adjustFontSize(2)"
                    nlr-click-once
                    tabindex="0"></i>
            </span>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <div class="input-group">
                    @for (option of viewOptions; track option; let i = $index) {
                        <label
                            class="nlr-radio"
                            title="{{option.toolTip}}">
                            <input
                                type="radio"
                                name="dolInstructedPlan"
                                [value]="option.value"
                                [(ngModel)]="planTypeSelected"
                                (ngModelChange)="planTypeChanged()"
                                required />
                            <span>{{option.displayValue}}</span>
                        </label>
                    }
                </div>
            </div>
        </div>
        <ul class="nav nav-pills results">
            <li
                [ngClass]="{active: isTabSelected(DASHBOARD_TAB.IN_DESIGN)}"
                title="Plans with a status of 'In Design'. 'In Design' plans are plans in the process of being prepared for lodgement."
                class="status-tab">
                <a
                    routerLink="{{tabRouterLinkPath}}"
                    id="inDesignTab"
                    (click)="selectTab(DASHBOARD_TAB.IN_DESIGN)">
                    <div class="badge">
                        {{getTabCounter(DASHBOARD_TAB.IN_DESIGN)}}
                    </div>
                    &nbsp;In design
                </a>
            </li>
            <li
                [ngClass]="{active: isTabSelected(DASHBOARD_TAB.READY_FOR_QA)}"
                title="Plans with a status of 'Ready for QA'. 'Ready for QA' plans are plans waiting to be QA'd."
                class="status-tab">
                <a
                    routerLink="{{tabRouterLinkPath}}"
                    id="readyForQaTab"
                    (click)="selectTab(DASHBOARD_TAB.READY_FOR_QA)">
                    <div
                        class="badge"
                        [ngClass]="{'error': showAlert(DASHBOARD_TAB.READY_FOR_QA)}">
                        {{getTabCounter(DASHBOARD_TAB.READY_FOR_QA)}}
                    </div>
                    &nbsp;Ready for QA
                </a>
            </li>
            <li
                [ngClass]="{active: isTabSelected(DASHBOARD_TAB.READY_FOR_CERTIFICATION)}"
                title="Plans with a status of 'Ready for Certification'. 'Ready for Certification' plans are plans waiting to be certified."
                class="status-tab">
                <a
                    routerLink="{{tabRouterLinkPath}}"
                    id="readyForCertificationTab"
                    (click)="selectTab(DASHBOARD_TAB.READY_FOR_CERTIFICATION)">
                    <div
                        class="badge"
                        [ngClass]="{'error': showAlert(DASHBOARD_TAB.READY_FOR_CERTIFICATION)}">
                        {{getTabCounter(DASHBOARD_TAB.READY_FOR_CERTIFICATION)}}
                    </div>
                    &nbsp;Ready for certification
                </a>
            </li>
            <li
                [ngClass]="{active: isTabSelected(DASHBOARD_TAB.CERTIFIED)}"
                title="Plans that are certified and are ready for lodgement."
                class="status-tab">
                <a
                    routerLink="{{tabRouterLinkPath}}"
                    id="readyForLodgementTab"
                    (click)="selectTab(DASHBOARD_TAB.CERTIFIED)">
                    <div class="badge">
                        {{getTabCounter(DASHBOARD_TAB.CERTIFIED)}}
                    </div>
                    &nbsp;Ready for lodgement
                </a>
            </li>
            <li
                [ngClass]="{active: isTabSelected(DASHBOARD_TAB.LODGED)}"
                title="Plans lodged with Landgate. These plans may be amended or replaced."
                class="status-tab">
                <a
                    routerLink="{{tabRouterLinkPath}}"
                    id="lodgedTab"
                    (click)="selectTab(DASHBOARD_TAB.LODGED)">
                    <div class="badge">
                        {{getTabCounter(DASHBOARD_TAB.LODGED)}}
                    </div>
                    &nbsp;Lodged
                </a>
            </li>
        </ul>

        <div
            class="pull-right mtm30"
            nlrp-permissions="{permissions: 'EDIT_PLAN'}">
            <button
                routerLink="/plan/{{PLAN_ACTION.NEW}}"
                routerLinkActive="router-link-active"
                type="button"
                id="createNewPlanBtn"
                class="btn btn-default nlr-btn-sm"
                title="Create new plan"
                nlr-click-once>
                Create plan
            </button>
        </div>

        <div>
            <h4>{{tabDescription}}</h4>
        </div>
    </div>

    <div class="row">
        <div class="col-xs-12">
            @if (filteredPlansData.length > pageSize) {
                <div class="dashboard-top-pagination">
                    <nlr-pagination
                        [currentPage]="currentPage"
                        [pageSize]="pageSize"
                        [collectionSize]="filteredPlansData.length"
                        [maxPageCount]="maxPageCount"
                        (pageChange)="paginatedCurrentPlansData($event)"></nlr-pagination>
                    @if (pageSize > 1) {
                        <div style="margin-bottom: 5px; clear: right; font-size: 12px;">
                            <span
                                class="pull-right"
                                style="margin-bottom: 5px; clear: right; font-size: 12px;">
                                Showing {{startIndex + 1}} to {{startIndex + filteredSize}} of {{filteredPlansData.length}}
                            </span>
                        </div>
                    }
                </div>
            }
        </div>
        <nlr-dashboard-result
            [selectedDashboardTab]="this.selectedTabType"
            [filters]="this.filters"
            (resetFiltersEvent)="resetFilters()"
            (assignPlanEvent)="assignPlanEvent()"
            (deletePlanEvent)="deletePlanEvent()"
            (modifyLodgedPlanEvent)="modifyLodgedPlanEvent($event)"
            (requestLatestLodgedVersion)="requestLatestLodgedVersion($event)"
            (sortEvent)="sortEvent($event)"></nlr-dashboard-result>
        @if (filteredPlansData.length > pageSize) {
            <div class="col-xs-12">
                <div class="dashboard-bottom-pagination">
                    <nlr-pagination
                        [currentPage]="currentPage"
                        [pageSize]="pageSize"
                        [collectionSize]="filteredPlansData.length"
                        [maxPageCount]="maxPageCount"
                        (pageChange)="paginatedCurrentPlansData($event)"></nlr-pagination>
                </div>
            </div>
        }
    </div>
</div>
